// Parcelas sem fornecedor — "(Fornecedor a definir)" (Rafael, 30/09).
//
// O Eventos pode lançar parcelas no card "(Fornecedor a definir)" da Previsão de
// Pagamento. O Financeiro pode APROVAR esse plano, mas não LIBERA para pagamento
// enquanto não houver fornecedor (camada 1 aqui; camada 2 é o 422 da API em
// liberarFinanceiro/aprovarCambio). Quando o operador escolhe o fornecedor na
// linha do orçamento, as parcelas passam para ele: o plano vira o do fornecedor
// (MOVE) ou fica vinculado ao plano que ele já tinha (LINK). Se as linhas foram
// para fornecedores diferentes, nada é atribuído e o card avisa (dividido).
//
// Campos do contrato (todos opcionais — API antiga = comportamento de antes):
//   Enviar para o Financeiro (card): a_definir, a_definir_dividido,
//     planos_vinculados[], pode_liberar_pagamento
//   Custo Previsto (plano): a_definir, fornecedor_definido, fornecedor_nome

export const FORN_A_DEFINIR = '_a_definir';
export const NOME_FORN_A_DEFINIR = '(Fornecedor a definir)';

export const MSG_AVISO_SEM_FORNECEDOR = 'Sem fornecedor, o Financeiro pode aprovar mas não libera para pagamento. Quando o fornecedor for cadastrado, escolha-o na linha do orçamento: as parcelas passam para ele.';
export const MSG_A_DEFINIR_DIVIDIDO = 'As linhas sem fornecedor foram para fornecedores diferentes. Lance as parcelas em cada fornecedor e exclua estas.';
export const MSG_A_DEFINIR_SEM_SALDO = 'Não há mais linhas sem fornecedor com valor no orçamento — não há o que prever aqui.';
// Mesma frase do 422 da API (liberarFinanceiro/aprovarCambio).
export const MSG_LIBERAR_SEM_FORNECEDOR = 'Fornecedor a definir: escolha o fornecedor na linha do orçamento antes de liberar para pagamento.';
// D-0127: mesma frase do 422 da API (liberarFinanceiro/aprovarCambio).
export const MSG_LIBERAR_NAO_VAI_CONTAS_PAGAR = 'Este fornecedor está marcado como "não vai para Contas a Pagar" na Previsão de Pagamento e não pode ser liberado para pagamento. Se ele precisar ser pago, peça ao operador do evento para desmarcar a opção.';
// D-0130/D-0131: mesma frase do 422 da API (TituloVivo::MSG_SEM_TITULO). A conta agora nasce sozinha no
// "Aprovar para pgto"; esta frase é só a reserva da pill quando a API não manda o motivo.
export const MSG_LIBERAR_SEM_TITULO = 'Este plano está aprovado, mas ainda não tem conta no Financeiro e ela não pôde ser criada automaticamente. Recarregue a tela e tente de novo.';
export const TAG_VINDO_DE_A_DEFINIR = 'vindo de Fornecedor a definir';

export function ehCardADefinir(forn) {
    return !!(forn && (forn.a_definir === true || forn.fornecedor_id === FORN_A_DEFINIR));
}

// Botão "+ Adicionar Parcela" da Previsão.
//   'ok'                 → habilitado
//   'a_definir_dividido' → desabilitado (o banner do card explica)
//   'a_definir_sem_saldo'→ desabilitado (bucket sem fornecedor zerado)
//   'teto_zero'          → desabilitado (tudo pago pelo cliente / fee)
export function estadoAdicionarParcela(forn, tetoBrl) {
    const teto = Number(tetoBrl) || 0;
    if (ehCardADefinir(forn)) {
        if (forn.a_definir_dividido === true) return 'a_definir_dividido';
        if (teto <= 0) return 'a_definir_sem_saldo';
        return 'ok';
    }
    if (teto <= 0) return 'teto_zero';
    return 'ok';
}

// Banners do card "(Fornecedor a definir)". Dividido substitui o aviso geral:
// ali a orientação é outra (lançar em cada fornecedor e excluir estas).
export function bannersCardADefinir(forn) {
    if (!ehCardADefinir(forn)) return { aviso: false, dividido: false };
    if (forn.a_definir_dividido === true) return { aviso: false, dividido: true };
    return { aviso: true, dividido: false };
}

// Planos "(Fornecedor a definir)" vinculados ao card do fornecedor Y (LINK).
// Somente leitura no front.
export function planosVinculadosDoCard(forn) {
    if (!forn || !Array.isArray(forn.planos_vinculados)) return [];
    return forn.planos_vinculados.filter(function (p) { return !!p; });
}

// Pill de status do plano vinculado (classes .fin-pp__pill).
export function pillStatusPlanoVinculado(status) {
    const mapa = {
        rascunho: { label: 'Rascunho', cls: 'is-muted' },
        enviado: { label: 'Aguardando aprovação', cls: 'is-warn' },
        aprovado: { label: 'Aprovado', cls: 'is-ok' },
        reprovado: { label: 'Reprovado', cls: 'is-danger' },
    };
    return mapa[status || 'rascunho'] || { label: String(status), cls: 'is-muted' };
}

// Data da parcela vinculada: mesmo campo das parcelas do próprio card
// (`data_pagamento`); `data_vencimento` só como reserva.
export function dataParcelaVinculada(parcela) {
    if (!parcela) return null;
    return parcela.data_pagamento || parcela.data_vencimento || null;
}

export function totalPlanoVinculado(plano) {
    if (!plano) return 0;
    const informado = Number(plano.valor_total);
    if (plano.valor_total !== null && plano.valor_total !== undefined && plano.valor_total !== '' && Number.isFinite(informado)) {
        return informado;
    }
    return (Array.isArray(plano.parcelas) ? plano.parcelas : []).reduce(function (s, p) {
        return s + (Number(p && p.valor) || 0);
    }, 0);
}

// D-0127: fornecedor pago pelo cliente (todos os itens com Fornecedor Pagamento = Cliente, `quem_paga`
// da API) não aparece na Previsão. Com parcela de antes da marcação o card fica, para Eventos ver e
// excluir — a API não aprova nem libera esse plano.
export const MSG_PAGO_PELO_CLIENTE = 'Pago pelo cliente: não vai para Contas a Pagar.';

export function ocultarNaPrevisaoPagoCliente(forn) {
    if (!forn || forn.quem_paga !== 'cliente') return false;
    const temParcela = (Array.isArray(forn.parcelas) && forn.parcelas.length > 0)
        || (Array.isArray(forn.parcelas_aprovadas) && forn.parcelas_aprovadas.length > 0)
        || planosVinculadosDoCard(forn).length > 0;
    return !temParcela;
}

// "Aprovar câmbio" (Efetivo) também libera para pagamento: só com fornecedor.
// undefined (API antiga) não bloqueia.
export function podeLiberarPagamentoCard(forn) {
    if (!forn) return true;
    if (forn.pode_liberar_pagamento === false) return false;
    return !ehCardADefinir(forn);
}

// ─── Custo Previsto (PainelParcelaPagar) ─────────────────────────────────

export function planoADefinir(plano) {
    return !!(plano && plano.a_definir === true);
}

export function planoVindoDeADefinir(plano) {
    return !!(plano && plano.fornecedor_definido === true && plano.a_definir !== true);
}

export function nomeFornecedorPlano(plano) {
    const nome = plano && plano.fornecedor_nome;
    if (nome) return nome;
    return planoADefinir(plano) ? NOME_FORN_A_DEFINIR : '';
}

// O que a coluna Ações da linha de Aprovados mostra no lugar do "Aprovar para pgto".
//   'liberado' | 'nao_vai' | 'a_definir' | 'sem_parcelas' | 'sem_titulo' | 'dados_pendentes' | 'liberar'
// Ordem: já liberado vence tudo; "não vai para Contas a Pagar" (D-0127) vem logo depois — não há
// pendência a resolver, ele não é liberado; sem fornecedor vem antes das outras pendências
// (sem fornecedor não há dado bancário a completar). D-0130/D-0131: aprovado sem conta viva no Financeiro
// e "vai para Contas a Pagar" — a conta nasce no clique (a API cria e libera); a pill só fica quando a API
// diz o que impede (conta_pendente_motivo, ex.: internacional pede a cotação). undefined não bloqueia.
export function acaoLiberacaoAprovado(item) {
    if (!item) return 'liberar';
    if (item.liberado_financeiro_at) return 'liberado';
    if (item.vai_contas_pagar === false) return 'nao_vai';
    if (item.a_definir === true) return 'a_definir';
    if (!item.parcelas_qt) return 'sem_parcelas';
    if (item.tem_conta_viva === false && item.conta_pendente_motivo) return 'sem_titulo';
    if (item.pagavel === false) return 'dados_pendentes';
    return 'liberar';
}
